// src/utils/imageUtils.ts
export function getImageUrl(imagePath: string): string {
  if (!imagePath) return '';

  // Check if it's already a full URL (CDN)
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Remove 'products/' prefix if present
  const cleanPath = imagePath.replace('products/', '');

  // Check if we're using CDN (production) or local (development)
  const useCDN = process.env.VUE_APP_USE_CDN === 'true';

  if (useCDN) {
    // Koristi CDN URL ako je postavljen, ili fallback na storage endpoint
    const cdnUrl =
      process.env.VUE_APP_CDN_URL ||
      `https://storage.bunnycdn.com/${process.env.VUE_APP_STORAGE_ZONE}`;
    return `${cdnUrl}/products/${cleanPath}`;
  } else {
    // Fallback to API URL for local/development
    const apiUrl = process.env.VUE_APP_API_URL;
    return `${apiUrl}/uploads/products/${cleanPath}`;
  }
}
